export const THEMES = {
  LIGHT: 'light',
  DARK: 'dark',
};

const THEME_STORAGE_KEY = 'siteTheme';

export const getStoredTheme = () => {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (stored === THEMES.DARK || stored === THEMES.LIGHT) {
      return stored;
    }
  } catch (error) {
    // fallback to light
  }
  return THEMES.LIGHT;
};

export const applyTheme = (theme) => {
  const safeTheme = theme === THEMES.DARK ? THEMES.DARK : THEMES.LIGHT;
  document.documentElement.setAttribute('data-theme', safeTheme);
};

export const saveTheme = (theme) => {
  const safeTheme = theme === THEMES.DARK ? THEMES.DARK : THEMES.LIGHT;
  try {
    localStorage.setItem(THEME_STORAGE_KEY, safeTheme);
  } catch (error) {
    // ignore persistence errors
  }
};
